import { Redirect } from 'expo-router';

export default function LearnHubAlias() {
  return <Redirect href="/learn" />;
}
